import { toast } from "react-toastify";
import API_BASE_URL from "../API/ConfigAPI";

// export const generateFacture = async () => {
//   const token = localStorage.getItem("token");
//   try {
//     await fetch(`${API_BASE_URL}/home/api/generate-facturations/`, {
//       method: "POST",
//       headers: { Authorization: `Token ${token}` },
//     });
//     toast.success("Facturation générée avec succès");
//   } catch (err) {
//     toast.error("Erreur lors de la génération de la facturation");
//   }
// };
export const generateFacture = async () => {
  const token = localStorage.getItem("token");
  try {
    const response = await fetch(`${API_BASE_URL}/home/api/generate-facturations/`, {
      method: "POST",
      headers: { Authorization: `Token ${token}` },
    });

    const data = await response.json();

    if (Array.isArray(data) && data.length > 0) {
      // 🚀 Si la réponse est une liste (ex : ["1 facturation générée"])
      data.forEach((message) => {
        toast.success(message);
      });
    } else if (data.message) {
      // 🚀 Sinon si on a une clé "message"
      toast.info(data.message);
    } else {
      toast.info("Opération terminée.");
    }
  } catch (err) {
    console.error("Erreur lors de la génération de la facturation:", err);
    toast.error("Erreur lors de la génération de la facturation.");
  }
};
export const exportFacture = async (mois, type) => {
  const token = localStorage.getItem("token");
  try {
    const res = await fetch(
      `${API_BASE_URL}/home/api/export_excel/${mois}/${type}/`,
      {
        headers: { Authorization: `Token ${token}` },
      }
    );
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `export_${mois}.xlsx`;
    a.click();
  } catch {
    toast.error("Erreur lors de l'export du fichier");
  }
};

export const sendFactureEmail = async ({ siret, mois }, onSuccess, onError, showToast = true) => {
  const token = localStorage.getItem("token");
  try {
    const res = await fetch(
      `${API_BASE_URL}/home/api/envoyer_facture/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify({ siret, mois_facturation: mois }),
      }
    );

    const data = await res.json();
   if (showToast) {
      toast.success(
        "Email envoyé avec succès le " +
          new Date(data.date_envoi_mail).toLocaleDateString("fr-FR")
      );
    }

    onSuccess?.(data);
  } catch (err) {
    console.error("Erreur Email:", err);
    toast.error("Erreur lors de l'envoi de l'email");
    onError?.(err);
  }
};

// apiHelpers.js
export const fetchWithToken = async (url, options = {}, parseJson = true) => {
  const token = localStorage.getItem("token");
  const config = {
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
      ...options.headers,
    },
    ...options,
  };

  const res = await fetch(url, config);
  if (!res.ok) throw new Error("Erreur réseau");
  return parseJson ? await res.json() : res;
};

export const fetchFacturations = async (moisFacturation = "") => {
  const token = localStorage.getItem("token");
  const query = moisFacturation ? `?mois_facturation=${moisFacturation}` : "";
  const response = await fetch(
    `${API_BASE_URL}/home/api/facturations/${query}`,
    {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error("Erreur lors de la récupération des facturations");
  }

  return await response.json();
};
